import {ChangeDetectionStrategy, Component} from "@angular/core";
import {FUIAbstractDomComponent} from "../../framework/abstract-dom";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-checkbox-dom",
    styleUrls: ["./checkbox-dom.component.scss"],
    templateUrl: "./checkbox-dom.component.html"
})
export class FUICheckboxDomComponent extends FUIAbstractDomComponent {
}
